module.exports = "/_next/static/images/ed28e7279aa132116cb78586579ab38f-group-man-building@3x.jpg.webp";